export default __webpack_public_path__ + "static/media/gasag_background_m1.48c3721b.jpg";